import { Allergen } from '@sg/graphql-schema';

import { type AllergenTypes } from './types';

// ─────────────────────────────────────────────────────────────────────────────

export function generateInitialContext(): Context {
  const preferences = INITIAL_ALLERGENS as AllergenTypes;

  return {
    preferences,
    pendingPreferences: preferences,
    activateAfterFetch: false,
    stayActiveAfterConfirm: false,
  };
}

// ─── Constants ───────────────────────────────────────────────────────────────

export const INITIAL_ALLERGENS: Record<Allergen, boolean> = {
  [Allergen.CrustaceanShellfish]: false,
  [Allergen.Eggs]: false,
  [Allergen.Milk]: false,
  [Allergen.Peanuts]: false,
  [Allergen.Sesame]: false,
  [Allergen.Soybeans]: false,
  [Allergen.TreeNuts]: false,
  [Allergen.Wheat]: false,
  [Allergen.Fish]: false,
  [Allergen.Meat]: false,
};

// ─── Types ───────────────────────────────────────────────────────────────────

export type Context = {
  preferences: AllergenTypes;
  pendingPreferences: AllergenTypes;
  activateAfterFetch: boolean;
  stayActiveAfterConfirm: boolean;
};
